var chunkMapping = {
	"2": [
		30002
	],
	"899": [
		60899
	],
	"1668": [
		51668
	],
	"1902": [
		41902
	],
	"1952": [
		21952
	],
	"2565": [
		62565
	],
	"2827": [
		22827
	],
	"3094": [
		60240
	],
	"4545": [
		24545
	],
	"4721": [
		54721
	],
	"4875": [
		74875
	],
	"5422": [
		43041
	],
	"5935": [
		95935
	],
	"6425": [
		96425
	],
	"6783": [
		56783
	],
	"6953": [
		86953
	],
	"7542": [
		87542
	],
	"7952": [
		87952
	],
	"8514": [
		48514
	],
	"8739": [
		8739
	]
};
var idToExternalAndNameMapping = {
	"8739": [
		"default",
		"./ProfessionalToPathwayAssigningModal",
		49119
	],
	"21952": [
		"default",
		"./QuickFilters",
		23799
	],
	"22827": [
		"default",
		"./AddContactModal",
		45573
	],
	"24545": [
		"default",
		"./PrintModal",
		6260
	],
	"30002": [
		"default",
		"./AddRelativesModal",
		45573
	],
	"41902": [
		"default",
		"./RemoveOrganizationRelation",
		45573
	],
	"43041": [
		"default",
		"./ActivityRightPanel",
		72698
	],
	"48514": [
		"default",
		"./EditRelativeRelationModal",
		45573
	],
	"51668": [
		"default",
		"./CitizenConditionDetailsModal",
		23799
	],
	"54721": [
		"default",
		"./RemoveRelativeContact",
		45573
	],
	"56783": [
		"default",
		"./RemoveCitizenRelativeContact",
		45573
	],
	"60240": [
		"default",
		"./DashboardWidgetDefinitions",
		23799
	],
	"60899": [
		"default",
		"./AddOrganizationsModal",
		45573
	],
	"62565": [
		"default",
		"./EditOrganizationRelationModal",
		45573
	],
	"74875": [
		"default",
		"./PatientConditionsWidget",
		23799
	],
	"86953": [
		"default",
		"./RemoveContact",
		45573
	],
	"87542": [
		"default",
		"./ProfessionalToPathwayUnassigningModal",
		49119
	],
	"87952": [
		"default",
		"./RemovePatientNetworkContact",
		45573
	],
	"95935": [
		"default",
		"./PatientPathwayDetailsModal",
		49119
	],
	"96425": [
		"default",
		"./LetterPathwayAttachmentModal",
		6260
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}